import { render, staticRenderFns } from "./TopicMap.vue?vue&type=template&id=10d8125b&scoped=true&"
import script from "./TopicMap.vue?vue&type=script&lang=js&"
export * from "./TopicMap.vue?vue&type=script&lang=js&"
import style0 from "./TopicMap.vue?vue&type=style&index=0&id=10d8125b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d8125b",
  null
  
)

export default component.exports